import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { BirthDateChangeCommandDataForm } from './BirthDateChangeCommandDataForm'

/**
 * Update the birthdate of a person is used when there is a need to change the birthdate of a person in the LegalEntity component and that birthdate will not be changed any other way via normal channels.
 *
 * @links
 * - [LegalEntity commands](@root/legalentity/legalentity-server/doc/solution/commands/LegalEntityCommands.md)
 * - @api legalentity-shared/legalentity.command.person.BirthDateChangeCommand, APIs for Birthdate@
 */
export function BirthDateChangeCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.crm.useBirthdayActions')({
    tenantId,
    personId: ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.BirthDateChangeCommandData"
      title={translate('birthdateChangeButton.button')}
      {...props}
      commandDataForm={BirthDateChangeCommandDataForm}
      submit={submit}
    />
  )
}
